/**
 * This is the box that is showed after click on Generate Payout right above the search.
 * It seems that this also trigger after select the Seller
 */
import React, {Component} from 'react';
import {Col, Row, Tabs, Tab, FormControl} from 'react-bootstrap';
import config from  '../../../config';
import json2csv   from 'json2csv'
import {Link} from 'react-router';
import moment   from 'moment'
import _ from 'lodash'
import formatNumbers  from 'util/formatNumbers';
import Select   from 'react-select'
import {calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';
const allReportFieldList = [
    {label: 'Type', value: 'Type'},
    {label: 'Status', value: 'Status'},
    {label: 'Amount Sold', value: 'Amount'},
    {label: 'Product Base Price With Discount', value: 'SaleData.ProductBasePriceWithDiscount'},
    {label: 'Discount Applied', value: 'SaleData.DiscountApplied'},
    {label: 'Location', value: 'MarketName'},
    {label: 'Product title', value: 'ProductID.ProductName'},
    {label: 'Shopify Product ID', value: 'ProductID.ShopifyProductID'},
    {label: 'COGS', value: 'SaleData.ProductCOGS'},
    {label: 'Payout Percentage', value: 'SaleData.PayoutPercentage'},

    {label: 'Dimensions', value:'Dimensions'},
    {label: 'Payout Amount', value:'CalculatedPayoutAmount'},

    {label: 'Description', value: 'Description'},
    {label: 'Seller', value: 'SellerID.DisplayName'},
    {label: 'Seller Location', value: 'SellerID.MarketName'},
    {label: 'Shopify Customer ID', value: 'UserID.ShopifyCustomerID'},
    {label: 'Seller email', value: 'UserID.email'},
    {label: 'Inventory Owner', value: 'InventoryOwner'},
    {label: 'Order Number', value: 'SaleData.OrderNumber'},
    {label: 'Sold At ', value: 'SoldAt'},
    {label: 'Fulfilled At ', value: 'FulfilledAt'},
    {label: 'Paid At ', value: 'PaidAt'},
    {label: 'Days to Sell', value: 'DaysToSell'},
    {label: 'Change Log ', value: 'ChangeLog'},
    {label: 'Deleted', value: 'Deleted'},
    {label: 'Last Updated', value: 'updatedAt'},
    {label: 'Scannable Partner LPN', value: 'ScannedLPN'}

]
var actionsList = [
    {'label': 'Delete transactions', value: 'DeleteTransactions'},
    {'label': 'Import transactions', value: 'ImportTransactions'},
]
export default class AdminTransactionActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
            pending: false,
            BulkActionNote: '',
            selectedAction: '',
            selectedActionData: {},
            displayTabs: {},
            reportFields: allReportFieldList
        };

    };

    calculatePayout(row) {

        if (row.Type == 'Sale') {
            if (_.isUndefined(row.SaleData.PayoutPercentage)) {
                console.log('Product payout is not available', row);
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Product payout is not available in transaction record'
                });
            }

             return  calculateTransactionPayoutAmount(row, this.props.appData.FeatureFlags);
        } else if (row.Type == 'Credit') {
            return '+' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'PickupFee') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'WorkingTime') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        }
    }
    downloadReport() {
        var methodData = {
            "endpoint": "/create-report",
            'type': 'post',
            'not_display_success_message': true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        var self = this;
        this.props.makeRequest({
            'transactions': this.props.adminTransactions.selectedTransactions,
            reportType: 'transactions'
        }, methodData).then(res => {
            var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })
            var dataToExport = _.map(res.data, function (recordData) {
                if (recordData.Type == 'Sale') {
                    if (_.get(recordData, 'SaleData.TimeToSell')) {
                        recordData.DaysToSell = _.get(recordData, 'SaleData.TimeToSell')
                    } else if (_.get(recordData, 'ProductID.0')) { /* TimeToSell is not available for  transactions created earlier */
                        var changeLogFound = _.find(_.get(recordData, 'ProductID.0.ChangeLog', []), (changeLog) => {
                            if (_.get(changeLog, 'FieldChanged', '') == 'Status' && _.get(changeLog, 'From', '') == 'Inactive' && _.get(changeLog, 'To', '') == 'Active') { /* PublishedInShopify does not exist in products added before 12.2018 */
                                return true
                            }
                        })

                        if (changeLogFound) {
                            var publishedInShopify = _.get(changeLogFound, 'CustomData.PublishedInShopify', false) ? changeLogFound.CustomData.PublishedInShopify : changeLogFound.Date
                        } else {
                            var publishedInShopify = moment(_.get(recordData, 'ProductID.0.createdAt')).add(5, 'days')
                            /* if changeLog not found assume it was pushed Live in 5 days after creation */
                        }

                        recordData.DaysToSell = moment(_.get(recordData, 'SoldAt')).diff(publishedInShopify, 'days')
                        console.log('  recordData.DaysToSell ', recordData.DaysToSell);
                    }
                }
                recordData.CalculatedPayoutAmount =self.calculatePayout(recordData)

                var OriginalProductData = _.get(recordData, 'ProductID.ProductVariants.0.OriginalProductData')
                if (_.get(OriginalProductData, 'Length') && _.get(OriginalProductData, 'Width') && _.get(OriginalProductData, 'Height')) {
                    recordData.Dimensions =_.get(OriginalProductData, 'Length','n/a') + ' x  '+_.get(OriginalProductData, 'Width','n/a')+' x '+_.get(OriginalProductData, 'Height','n/a')
                }
                return recordData
            })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
                unwindPath: 'UserID'
            })

            console.log('res.data', res.data);
            var filename = "transactions_report_" + moment().format("YYYY-MM-DD-HH-mm") + ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            console.log('err', err);
        });
    }

    onSelectTab(event) {
        this.setState({displayTabs: {...this.state.displayTabs, [event]: !this.state.displayTabs[event]}})
    }

    triggerSelectedAction() {
        var methodData = {
            "endpoint": "/transactions-process-action",
            'type': 'post',
        };


        var self = this;
        self.setState({pending: true})
        this.props.makeRequest({
            'action': self.state.selectedAction,
            'Note': this.state.BulkActionNote,
            'recordIDs': this.props.adminTransactions.selectedTransactions
        }, methodData).then(response => {
            self.setState({pending: false})
            this.props.search()
            if (_.get(response, ['data', 'clientMessage'], '')) {
                this.props.displayMessage({
                    'messageCode': _.get(response, ['data', 'clientMessage'], '')
                });
            } else {
                return this.props.displayMessage({
                    'messageCode': 'Action processed'
                });
            }

        }).catch(error => {
            console.log('error', error);
            self.setState({pending: false})
        });
    }

    onChange(event) {
        if (this.state.pending) {
            return false;
        } else {
            this.setState({pending: true, selectedActionData:{}})
        }
        var data = new FormData();
        data.append('file', event.target.files[0]);
        var methodData = {

            endpoint: 'transactions/import_transactions',
            type: 'post'
        }
        this.props.makeRequest(data, methodData).then(function (response) {
            this.fileUploadInput.value = "";
            this.setState({
                pending: false, selectedActionData: {
                    ImportedTransactionActionID: _.get(response.data, 'ActionID')
                }
            })
            this.props.displayMessage({
                'messageCode': (response.data.ImportedTransactionsNumber == 1 ? '1 transaction' : response.data.ImportedTransactionsNumber + ' transactions') + ' imported'
            });
        }.bind(this)).catch(function (err) {
            this.fileUploadInput.value = "";
            this.props.displayMessage({
                messageType:'warning',
                'messageCode': 'Transactions were not imported'
            });
            this.setState({pending: false})
        }.bind(this));

    }

    render() {
         return (
            <div className="transaction-action-block top20">
                <Tabs defaultActiveKey={'reports'} onSelect={(e) => {
                    this.onSelectTab(e)
                }} id="userActionBox">

                    <Tab eventKey={'reports'}
                         className={_.get(this.state.displayTabs, ['reports'], false) ? '' : 'hidden'}
                         unmountOnExit={true} title="Reports">
                        <Row >
                            <Col md={4} xs={4} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.reportFields}
                                />
                            </Col>

                        </Row>
                        <Row>
                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ this.downloadReport.bind(this)}
                                        type="button">
                                    Download report
                                </button>
                            </Col>
                        </Row>
                    </Tab>
                    { _.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 &&

                    <Tab eventKey={'actions'}
                         className={_.get(this.state.displayTabs, ['actions'], false) ? '' : 'hidden'}
                         unmountOnExit={true} title="Actions">
                        <Row className="show-grid">


                            <Col lg={3} md={4} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    clearable={true}
                                    placeholder="Action"
                                    options={actionsList}
                                    onChange={(option) => {
                                        this.setState({
                                            selectedAction: option ? option.value : null,
                                            selectedActionData: {},
                                        })
                                    }}
                                    value={this.state.selectedAction}
                                />
                            </Col>
                            { this.state.selectedAction == 'DeleteTransactions' &&
                            <Col lg={3} md={4} xs={6} className="top10">
                                <FormControl type="text"
                                             defaultValue={this.state.BulkActionNote}
                                             onChange={ (event) => this.setState({BulkActionNote: event.target.value})}
                                             placeholder="Note for action"/>
                            </Col>
                            }
                            { this.state.selectedAction == 'ImportTransactions' &&
                            <Col lg={3} md={4} xs={6} className="top10">
                                <input type="file" disabled={this.state.pending}
                                       ref={(ref) => this.fileUploadInput = ref}
                                       onChange={(e) => this.onChange(e)}
                                       style={{display: 'none'}}/>
                                <button onClick={(e) => this.fileUploadInput.click() }
                                        disabled={this.state.pending}
                                        className={'btn btn-primary'}>
                                    Upload CSV
                                </button>

                            </Col>
                            }
                            {_.get(this.state, 'selectedActionData.ImportedTransactionActionID') &&
                            <Col md={3} xs={3} className="top10">


                                <Link className="left10" target="_blank"
                                      to={'/admin/payout-registry?Statuses=[]&searchText=' + _.get(this.state, 'selectedActionData.ImportedTransactionActionID')}>View
                                    imported records</Link>


                            </Col>
                            }
                            { this.state.selectedAction !== 'ImportTransactions' &&
                            <Col md={3} xs={3} className="top10">
                                <button className="btn btn-primary bg-red border-red"
                                        onClick={this.triggerSelectedAction.bind(this)}
                                        disabled={!this.state.selectedAction || this.state.pending}
                                        type="button">
                                    Run action
                                </button>
                            </Col>
                            }
                        </Row>
                    </Tab>
                    }
                </Tabs>
            </div>
        );

    }
}



